export default "__VITE_ASSET__BAxUNZTA__"